import { Data } from "../../types/Data";
import { State } from "../../types/State";

export function getLabelTypeDeBien({
  state,
  data,
  defaultLabel,
}: {
  state: State;
  data: Data;
  defaultLabel: string;
}) {
  if (!state["type-de-bien"] || state["type-de-bien"].length === 0)
    return defaultLabel;
  return state["type-de-bien"]
    .map((value) => data["type-de-bien"][value].label)
    .join(", ");
}
